import AlchemistIcon from "./Icons/AlchemistIcon";
import BlacksmithIcon from "./Icons/BlacksmithIcon";
import ShopIcon from "./Icons/ShopIcon";
import SwordsIcon from "./Icons/SwordsIcon";
import TailorIcon from "./Icons/TailorIcon";
import TakeIcon from "./Icons/TakeIcon";
import TgStarIcon from "./Icons/TgStarIcon.js";
import audioManager from "./Sounds.js";

const CityWindow = ({
  t,
  setNowOpen,
  motion,
  openAdventures,
  openShop,
  openBlacksmith,
  openTailor,
  openAlchemist,
  openPirate,
}) => {
  return (
    <>
      <div className="inventory-title">
        <div className="invenory-title-text">{t("Starholm")}</div>
        <TakeIcon
          onClick={() => {
            setNowOpen(null);

            audioManager.play("s_auraBg");
            audioManager.stop("s_city");
          }}
          className="back-icon"
          fill="#e0e0e0dc"
          size="20px"
        ></TakeIcon>
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="inventory-container add-ui-container"
      >
        <div>
          <div className="city-block-wrapper">
            <div
              onClick={openAdventures}
              style={{
                backgroundImage: "url(city-images/adventures.webp)",
              }}
              className="city-block-container"
            >
              <div className="city-block-title">{t("Adventures")}</div>
              <SwordsIcon size="42px"></SwordsIcon>
            </div>
          </div>
        </div>
        {/* <div>
          <div onClick={openPirate} className="city-block-wrapper">
            <div
              style={{
                backgroundImage: "url(city-images/pirate.webp)",
              }}
              className="city-block-container"
            >
              <div className="city-block-title">{t("Pirate Bay")}</div>
              <TgStarIcon size="42px"></TgStarIcon>
            </div>
          </div>
        </div> */}
        <div>
          <div className="city-block-wrapper">
            <div
              onClick={openShop}
              style={{
                backgroundImage: "url(city-images/shop2.webp)",
              }}
              className="city-block-container"
            >
              <div className="city-block-title">{t("AbigailPlace")}</div>
              <ShopIcon size="42px"></ShopIcon>
            </div>
          </div>
        </div>

        <div>
          <div onClick={openBlacksmith} className="city-block-wrapper">
            <div
              style={{
                backgroundImage: "url(city-images/blacksmith.webp)",
              }}
              className="city-block-container"
            >
              <div className="city-block-title">{t("GatanoaPlace")}</div>
              <BlacksmithIcon size="42px"></BlacksmithIcon>
            </div>
          </div>
        </div>

        <div>
          <div onClick={openTailor} className="city-block-wrapper">
            <div
              style={{
                backgroundImage: "url(city-images/tailor2.webp)",
              }}
              className="city-block-container"
            >
              <div className="city-block-title">{t("ElunaPlace")}</div>
              <TailorIcon size="38px"></TailorIcon>
            </div>
          </div>
        </div>

        <div>
          <div onClick={openAlchemist} className="city-block-wrapper">
            <div
              style={{
                backgroundImage: "url(city-images/alchemist.webp)",
              }}
              className="city-block-container"
            >
              <div className="city-block-title">{t("ChonkPlace")}</div>
              <AlchemistIcon size="42px"></AlchemistIcon>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};
export default CityWindow;
